import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { USER_GET_TOS_TERMS_ENDPOINT } from 'src/app/constants/api-routes';
import { User } from 'src/app/model/User';
import { UserService } from 'src/app/services/user/user.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-tos-content',
    templateUrl: './tos-content.component.html',
    styleUrls: ['./tos-content.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TosContentComponent implements OnInit {
  /** TOS Content */
  public tosHTML: string = "<strong>No terms of service available for your role. Please contact an administrator.</strong>";

  /** Whether or not TOS has been fetched */
  public tosFetched: boolean = false;

  /**
   * Constructor to initialize services
   */
  constructor(
    private _http: HttpClient,
    private _userService: UserService,
  ) {}

  /**
   * On init lifecycle hook, sets the TOS content based on the user role
   */
  ngOnInit(): void {
    // Wait for the user to be initialized
    this._userService.user$.subscribe((user: User | null) => {
      if (user === null) return;

      // Get company ID
      const companyId = this._userService.company?.companyId;
      if (companyId == undefined) {
        console.error("[ERR]: when fetching TOS, companyId is undefined");
        return;
      }

      // Fetch TOS
      this._http.get(USER_GET_TOS_TERMS_ENDPOINT(companyId, user.id), { responseType: 'text' }).subscribe({
        // On success, set the TOS content
        next: (raw: string) => {
          // Rendered via [appSanitizedHtml], which sanitizes with DOMPurify
          this.tosHTML = raw;
          this.tosFetched = true;
        },
        // On error, log
        error: (error) => {
          console.error("[ERR]: when fetching TOS", error);
          this.tosFetched = true;
        },
      });
    })
  }
}
